/** @format */

import {Link, useParams} from 'react-router-dom';
import React from 'react';

export function ActionColumn(props) {
    const {id} = useParams();

    if (Number(props.order_id) === Number(id)) return <p className="m-0 p-0">{props.order_id}</p>;

    return (
        <Link
            className="color-accent-primary d-flex align-items-center justify-content-start gap-2"
            to={'/account/orders/view/' + props.order_id}
            rel="noopener noreferrer"
            target="_blank">
            <i className="fa fa-up-right-from-square" />
            <u>{props.order_id}</u>
        </Link>
    );
}
